/**
 * Reusable card for facility standards (Soil Load, Water Changes, Work Shifts).
 * Single responsibility: display title + badge (or "Not set") + chevron; delegate click to parent.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRight } from 'lucide-react';
import { STANDARD_SET_BADGE_CLASS, STANDARD_NOT_SET_BADGE_CLASS } from '../../utils/standardsDisplayUtils';

const CARD_BUTTON_CLASS =
  'group w-full bg-white rounded-[12px] px-5 py-4 flex items-center justify-between transition-all duration-200 border border-[#e5e5e5] hover:border-2 hover:border-[#61b8e7] hover:shadow-md hover:bg-gray-50';
const TITLE_CLASS = "font-['Roboto:SemiBold',sans-serif] font-semibold text-[16px] text-black";

export function StandardCard({ title, badgeLabel, onClick }) {
  const isSet = badgeLabel != null && badgeLabel !== '';
  return (
    <button type="button" onClick={onClick} className={CARD_BUTTON_CLASS}>
      <h3 className={TITLE_CLASS}>{title}</h3>
      <div className="flex items-center gap-3">
        <span className={isSet ? STANDARD_SET_BADGE_CLASS : STANDARD_NOT_SET_BADGE_CLASS}>
          {isSet ? badgeLabel : 'Not set'}
        </span>
        <ChevronRight className="w-5 h-5 text-gray-400 transition-colors group-hover:text-[#61b8e7] shrink-0" />
      </div>
    </button>
  );
}

StandardCard.propTypes = {
  title: PropTypes.string.isRequired,
  /** Display text when set; null/empty shows "Not set". */
  badgeLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
